import React, { useEffect, useState } from "react";

import {
  getDatesRange,
  getMonthFirstDate,
  getMonthLastDate,
  getMonthRange,
  TheMonths,
} from "./MyCalendar";
import styled from "styled-components";
import {
  FormControlBlack,
  FormSelectBlack,
} from "../pages/components/PageParams";
import { months } from "moment";
import { dateFilter } from "react-bootstrap-table2-filter";

export default function MonthSelector(props) {
  const { title } = { props };
  const [info, setInfo] = props.info;
  const [seleMonth, setSeleMonth] = useState({
    forMonth: new Date().getMonth() + 1,
    forYear: new Date().getFullYear(),
  });

  // useEffect(() => {
  //   if (info === null) {
  //     setInfo({
  //       month: seleMonth.forMonth,
  //       year: new Date().getFullYear(),
  //       dates: [
  //         getMonthFirstDate(new Date().getFullYear(), new Date().getMonth()),
  //         getMonthLastDate(new Date().getFullYear(), new Date().getMonth()),
  //       ],
  //     });
  //   }
  // }, [info]);

  const onMonthSelectedChange = (e) => {
    setSeleMonth((p) => {
      p.forMonth = e.target.value;
      return { ...p };
    });
  };

  //** เปลี่ยน พศ. */
  const onYearChanged = (e) => {
    setSeleMonth((p) => {
      p.forYear = Number(e.target.value - 543);
      return { ...p };
    });
  };

  useEffect(() => {
    setInfo({
      month: seleMonth.forMonth,
      year: seleMonth.forYear,
      dates: getDatesRange(seleMonth.forYear, seleMonth.forMonth),
    });
  }, [seleMonth]);

  const yearKeyDown = (e) => {
    switch (e.which) {
      case 38:
        e.target.value = Number(e.target.value) + 1;
        onYearChanged(e);
        break;
      case 40:
        e.target.value = Number(e.target.value) - 1;
        onYearChanged(e);
        break;
      default:
        break;
    }
  };

  return (
    <DivRowItem>
      <SpanLabel className="caption">{title ?? "เดือน"}</SpanLabel>

      <FormSelectBlack
        {...{
          rows: TheMonths,
          fieldId: "id",
          fieldValue: "name",
          onChange: onMonthSelectedChange,
          defaultValue: info?.month ?? new Date().getMonth() + 1,
        }}
      />

      <FormControlBlack
        type="text"
        onChange={onYearChanged}
        defaultValue={seleMonth.forYear + 543}
        style={{ width: "80px", textAlign: "center" }}
        onKeyDown={yearKeyDown}
      ></FormControlBlack>
    </DivRowItem>
  );
}

const DivRowItem = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px;
`;

const SpanLabel = styled.div`
  background-color: transparent;
  padding: 5px 15px 5px 5px;
  color: var(--caption-fore-color);
`;
